import { AlmacenInputProps, AlmacenOutputProps } from '../interfaces/index'

export const almacenRegistroComposeService = (
  input: AlmacenInputProps,
): AlmacenOutputProps => {
  return {
    nombre: input.nombre,
    ubicacion: input.ubicacion,
    codigoSucursal: input.codigoSucursal?.codigo ?? 0,
  }
}
